export type AutoReplyMessageConfig = {
  message: string
}

export enum BusinessHours {
  AFTER_HOURS = 'AFTER_HOURS',
  DURING_HOURS = 'DURING_HOURS',
}
